import React from 'react';

const PotentialsFootnote1 = () => (
  <>
    <sup>1</sup> Wenn die PendlerInnen an 80% der Arbeitstage im Jahr die jeweils empfohlenen Routen nehmen.
  </>
);

export default PotentialsFootnote1;
